import React from "react";
import { C, mono } from "../config/theme";
import { fmt, pct } from "../utils/format";

export default function KpiCard({ label, value, valueN1, color = C.accent, sparkData = [], annee, suffix = "", isCurrency = true, onClick, selected = false }) {
  const evolution = pct(value, valueN1);
  const isUp = evolution != null && evolution > 0;
  const isDown = evolution != null && evolution < 0;
  const maxVal = Math.max(...sparkData.filter((v) => v > 0), 1);
  const minVal = Math.min(...sparkData.filter((v) => v >= 0), 0);
  const range = maxVal - minVal || 1;

  const sparkW = 80;
  const sparkH = 40;
  const points = sparkData.length > 1
    ? sparkData.map((v, i) => ({
        x: (i / Math.max(sparkData.length - 1, 1)) * sparkW,
        y: sparkH - ((v - minVal) / range) * (sparkH - 4) - 2,
      }))
    : [];

  let displayValue;
  if (suffix === "%") {
    displayValue = `${(value || 0).toFixed(1).replace(".", ",")} %`;
  } else if (!isCurrency) {
    displayValue = Math.round(value || 0).toLocaleString("fr-FR");
  } else {
    displayValue = fmt(value);
  }

  return (
    <div
      onClick={onClick}
      style={{
        background: C.surface, borderRadius: 14,
        border: selected ? `2px solid ${color}` : `1px solid ${C.border}`,
        padding: "20px 24px", position: "relative", overflow: "hidden",
        boxShadow: selected ? `0 0 0 3px ${color}20` : "0 1px 8px rgba(0,0,0,0.05)",
        flex: 1, minWidth: 200,
        cursor: onClick ? "pointer" : "default",
        transition: "all 150ms",
      }}
    >
      {points.length > 1 && (
        <svg
          viewBox={`0 0 ${sparkW} ${sparkH}`}
          preserveAspectRatio="none"
          style={{ position: "absolute", top: 16, right: 16, width: 80, height: 40, opacity: 0.6 }}
        >
          <defs>
            <linearGradient id={`sg-${label.replace(/\s/g, "")}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity="0.15" />
              <stop offset="100%" stopColor={color} stopOpacity="0" />
            </linearGradient>
          </defs>
          <path
            fill={`url(#sg-${label.replace(/\s/g, "")})`}
            d={`M${points[0].x},${sparkH} ` + points.map((p) => `L${p.x},${p.y}`).join(" ") + ` L${points[points.length - 1].x},${sparkH} Z`}
          />
          <polyline fill="none" stroke={color} strokeWidth={2} strokeLinejoin="round" strokeLinecap="round"
            points={points.map((p) => `${p.x},${p.y}`).join(" ")} />
        </svg>
      )}

      <div style={{ position: "relative", zIndex: 1 }}>
        <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: color, marginBottom: 10 }}>
          {label}
        </div>
        <div style={{ fontSize: 30, fontWeight: 800, color: C.text, fontFamily: mono, lineHeight: 1 }}>
          {displayValue}
        </div>
        {(evolution != null || (annee && valueN1 != null)) && (
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 10 }}>
            {evolution != null && (
              <span style={{ fontSize: 13, fontWeight: 700, fontFamily: mono, color: isUp ? C.green : isDown ? C.red : C.slate }}>
                {isUp ? "+" : ""}{evolution.toFixed(1)}%
              </span>
            )}
            {annee && valueN1 != null && (
              <span style={{ fontSize: 12, color: C.slateLight }}>vs {annee - 1}</span>
            )}
          </div>
        )}
        {onClick && (
          <div style={{ fontSize: 10, color: C.slateLight, marginTop: 8 }}>
            {selected ? "▲ Cliquer pour fermer" : "▼ Cliquer pour le détail"}
          </div>
        )}
      </div>
    </div>
  );
}